define('AwaLabs.CLS', [
    'jQuery',
    'underscore'
], function CLS(
    jQuery,
    _
) {
    'use strict';
    
    // Función para obtener información del elemento
    function getElementInfo(element) {
        if (!element) {
            return 'Unknown element';
        }
        
        var tagName = element.tagName || '';
        var id = element.id || '';
        var className = element.className || '';
        var selector = tagName.toLowerCase();
        
        if (id) {
            selector += '#' + id;
        }
        if (className && typeof className === 'string') {
            selector += '.' + className.split(' ').join('.');
        }
        
        var rect;
        try {
            if (element && typeof element.getBoundingClientRect === 'function') {
                rect = element.getBoundingClientRect();
            } else {
                rect = { width: 0, height: 0, top: 0, left: 0 };
            }
        } catch (e) {
            rect = { width: 0, height: 0, top: 0, left: 0 };
        }
        var dimensions = {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            top: Math.round(rect.top),
            left: Math.round(rect.left)
        };
        
        return {
            selector: selector,
            tagName: tagName,
            id: id,
            className: className,
            dimensions: dimensions,
            element: element
        };
    }
    
    // Función para obtener el path completo del elemento
    function getElementPath(element) {
        if (!element || !element.parentNode) {
            return '';
        }
        
        var path = [];
        var current = element;
        
        while (current && current !== document.body && current !== document.documentElement) {
            var selector = current.tagName ? current.tagName.toLowerCase() : '';
            if (current.id) {
                selector += '#' + current.id;
            } else if (current.className && typeof current.className === 'string') {
                var classes = current.className.split(' ').filter(function(c) { return c; });
                if (classes.length > 0) {
                    selector += '.' + classes[0];
                }
            }
            path.unshift(selector);
            current = current.parentNode;
        }
        
        return path.join(' > ');
    }
    
    // Función para obtener CSS aplicado a un elemento
    function getComputedStyles(element) {
        if (!element || !window.getComputedStyle) {
            return {};
        }
        
        try {
            var styles = window.getComputedStyle(element);
            return {
                position: styles.position,
                display: styles.display,
                width: styles.width,
                height: styles.height,
                minWidth: styles.minWidth,
                minHeight: styles.minHeight,
                maxWidth: styles.maxWidth,
                maxHeight: styles.maxHeight,
                margin: styles.margin,
                padding: styles.padding,
                top: styles.top,
                right: styles.right,
                bottom: styles.bottom,
                left: styles.left,
                transform: styles.transform,
                visibility: styles.visibility,
                opacity: styles.opacity
            };
        } catch (e) {
            return { error: e.message };
        }
    }
    
    // Función para detectar qué cambió
    function detectChanges(previousRect, currentRect, styles) {
        var changes = [];
        
        if (previousRect.width !== currentRect.width) {
            changes.push('width: ' + previousRect.width + ' → ' + currentRect.width + ' (' + (currentRect.width - previousRect.width) + 'px)');
        }
        if (previousRect.height !== currentRect.height) {
            changes.push('height: ' + previousRect.height + ' → ' + currentRect.height + ' (' + (currentRect.height - previousRect.height) + 'px)');
        }
        if (previousRect.x !== currentRect.x) {
            changes.push('x: ' + previousRect.x + ' → ' + currentRect.x + ' (' + (currentRect.x - previousRect.x) + 'px)');
        }
        if (previousRect.y !== currentRect.y) {
            changes.push('y: ' + previousRect.y + ' → ' + currentRect.y + ' (' + (currentRect.y - previousRect.y) + 'px)');
        }
        
        return changes;
    }
    
    // Función para loggear layout shifts
    function logLayoutShift(entry) {
        if (!entry.hadRecentInput && entry.value > 0) {
            var sources = entry.sources || [];
            var currentTime = Math.round(performance.now());
            var shiftInfo = {
                score: entry.value.toFixed(4),
                time: currentTime,
                sources: []
            };
            
            if (sources.length > 0) {
                sources.forEach(function(source, index) {
                    var node = source.node;
                    var elementInfo = getElementInfo(node);
                    var path = getElementPath(node);
                    var styles = getComputedStyles(node);
                    var changes = detectChanges(source.previousRect, source.currentRect, styles);
                    
                    var sourceInfo = {
                        index: index + 1,
                        element: elementInfo.selector,
                        path: path,
                        previousRect: {
                            x: Math.round(source.previousRect.x),
                            y: Math.round(source.previousRect.y),
                            width: Math.round(source.previousRect.width),
                            height: Math.round(source.previousRect.height)
                        },
                        currentRect: {
                            x: Math.round(source.currentRect.x),
                            y: Math.round(source.currentRect.y),
                            width: Math.round(source.currentRect.width),
                            height: Math.round(source.currentRect.height)
                        },
                        changes: changes,
                        styles: styles
                    };
                    
                    shiftInfo.sources.push(sourceInfo);
                });
            }
            
            // Guardar en window para acceso global
            if (!window.CLSLogs) {
                window.CLSLogs = [];
            }
            window.CLSLogs.push(shiftInfo);
        }
    }
    
    // Función para monitorear elementos problemáticos específicos
    function monitorProblemElements() {
        var problemSelectors = [
            '.summer-trends-container',
            '.site-search-custom',
            '.bottom-finder',
            '#n8n-chat .chat-window-wrapper',
            '[data-cms-area]',
            '[data-view]'
        ];
        
        var monitoredElements = {};
        
        function checkElements() {
            problemSelectors.forEach(function(selector) {
                var elements = document.querySelectorAll(selector);
                var elementsArray = Array.prototype.slice.call(elements);
                elementsArray.forEach(function(element, index) {
                    var key = selector + '[' + index + ']';
                    var rect = element.getBoundingClientRect();
                    var styles = getComputedStyles(element);
                    
                    if (!monitoredElements[key]) {
                        monitoredElements[key] = {
                            selector: selector,
                            element: element,
                            initialRect: {
                                x: Math.round(rect.x),
                                y: Math.round(rect.y),
                                width: Math.round(rect.width),
                                height: Math.round(rect.height)
                            },
                            initialStyles: styles,
                            changes: []
                        };
                    } else {
                        var current = {
                            x: Math.round(rect.x),
                            y: Math.round(rect.y),
                            width: Math.round(rect.width),
                            height: Math.round(rect.height)
                        };
                        
                        var initial = monitoredElements[key].initialRect;
                        var hasChanged = (
                            current.x !== initial.x ||
                            current.y !== initial.y ||
                            current.width !== initial.width ||
                            current.height !== initial.height
                        );
                        
                        if (hasChanged && monitoredElements[key].changes.length === 0) {
                            monitoredElements[key].changes.push({
                                time: Math.round(performance.now()),
                                from: initial,
                                to: current,
                                styles: styles
                            });
                        }
                    }
                });
            });
        }
        
        // Monitorear cada 100ms durante los primeros 5 segundos
        var checkInterval = setInterval(checkElements, 100);
        setTimeout(function() {
            clearInterval(checkInterval);
        }, 5000);
        
        // También monitorear cuando el DOM cambia
        if (typeof MutationObserver !== 'undefined') {
            var mutationObserver = new MutationObserver(function(mutations) {
                checkElements();
            });
            
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style', 'class']
            });
        }
        
        return monitoredElements;
    }
    
    // Función para inicializar el observer de CLS
    function initCLSObserver() {
        if (typeof PerformanceObserver === 'undefined') {
            return;
        }
        
        try {
            var observer = new PerformanceObserver(function(list) {
                var entries = list.getEntries();
                entries.forEach(function(entry) {
                    logLayoutShift(entry);
                });
            });
            
            observer.observe({ entryTypes: ['layout-shift'] });
            
            // Log inicial
            window.CLSLogs = [];
            
            // Iniciar monitoreo de elementos problemáticos
            setTimeout(function() {
                window.CLSMonitoredElements = monitorProblemElements();
            }, 500);
            
        } catch (e) {
            // Silently fail
        }
    }
    
    // Función para establecer altura inicial en elementos problemáticos
    function setInitialHeights() {
        // Establecer altura inicial para summer-trends-container
        var summerTrendsContainer = document.querySelector('.summer-trends-container');
        if (summerTrendsContainer) {
            var windowWidth = window.innerWidth || document.documentElement.clientWidth;
            
            // Determinar min-height basado en el breakpoint
            var minHeight;
            if (windowWidth >= 1200) {
                minHeight = 326;
            } else if (windowWidth >= 992) {
                minHeight = 326;
            } else if (windowWidth >= 768) {
                minHeight = 326;
            } else if (windowWidth >= 480) {
                minHeight = 700;
            } else {
                minHeight = 700;
            }
            
            // Establecer min-height siempre, sin importar la altura actual
            if (!summerTrendsContainer.style.minHeight || parseInt(summerTrendsContainer.style.minHeight) < minHeight) {
                summerTrendsContainer.style.setProperty('min-height', minHeight + 'px', 'important');
                summerTrendsContainer.style.setProperty('min-width', '100%', 'important');
                summerTrendsContainer.style.setProperty('display', 'block', 'important');
            }
        }
        
        // Establecer altura inicial para bottom-finder
        var bottomFinder = document.querySelector('.bottom-finder');
        if (bottomFinder) {
            if (!bottomFinder.style.minHeight || parseInt(bottomFinder.style.minHeight) < 188) {
                bottomFinder.style.setProperty('min-height', '188px', 'important');
                bottomFinder.style.setProperty('min-width', '100%', 'important');
            }
        }
        
    }
    
    // Función para establecer altura inmediatamente cuando se detecta un elemento
    function setHeightImmediately(element, minHeight, minWidth) {
        if (element && element.nodeType === 1) {
            element.style.setProperty('min-height', minHeight + 'px', 'important');
            if (minWidth) {
                element.style.setProperty('min-width', minWidth, 'important');
            }
            element.style.setProperty('display', 'block', 'important');
        }
    }
    
    // Función para verificar y restaurar altura si el elemento se colapsa
    function checkAndRestoreHeight(element, minHeight, minWidth) {
        if (!element || element.nodeType !== 1) {
            return;
        }
        
        var rect = element.getBoundingClientRect();
        var computedStyle = window.getComputedStyle(element);
        
        // Si el elemento tiene width o height 0, restaurar altura
        if (rect.width === 0 || rect.height === 0 || computedStyle.display === 'none' || computedStyle.visibility === 'hidden') {
            setHeightImmediately(element, minHeight, minWidth);
        }
    }
    
    // MutationObserver agresivo para detectar elementos tan pronto como se crean
    function setupAggressiveObserver() {
        if (typeof MutationObserver === 'undefined') {
            return;
        }
        
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // Verificar elementos existentes que puedan haberse colapsado
                var summerTrendsContainer = document.querySelector('.summer-trends-container');
                if (summerTrendsContainer) {
                    var windowWidth = window.innerWidth || document.documentElement.clientWidth;
                    var minHeight = windowWidth >= 768 ? 326 : 700;
                    checkAndRestoreHeight(summerTrendsContainer, minHeight, '100%');
                }
                
                var bottomFinder = document.querySelector('.bottom-finder');
                if (bottomFinder) {
                    checkAndRestoreHeight(bottomFinder, 188, '100%');
                }
                
                
                if (mutation.addedNodes.length > 0) {
                    var addedNodesArray = Array.prototype.slice.call(mutation.addedNodes);
                    addedNodesArray.forEach(function(node) {
                        if (node.nodeType === 1) { // Element node
                            // Detectar summer-trends-container
                            if (node.classList && node.classList.contains('summer-trends-container')) {
                                var windowWidth = window.innerWidth || document.documentElement.clientWidth;
                                var minHeight = windowWidth >= 768 ? 326 : 700;
                                setHeightImmediately(node, minHeight, '100%');
                            }
                            
                            // Detectar bottom-finder
                            if (node.classList && node.classList.contains('bottom-finder')) {
                                setHeightImmediately(node, 188, '100%');
                            }
                            
                            
                            // Buscar elementos dentro del nodo agregado
                            var summerTrends = node.querySelector && node.querySelector('.summer-trends-container');
                            if (summerTrends) {
                                var windowWidth = window.innerWidth || document.documentElement.clientWidth;
                                var minHeight = windowWidth >= 768 ? 326 : 700;
                                setHeightImmediately(summerTrends, minHeight, '100%');
                            }
                            
                            var bottomFinder = node.querySelector && node.querySelector('.bottom-finder');
                            if (bottomFinder) {
                                setHeightImmediately(bottomFinder, 188, '100%');
                            }
                            
                        }
                    });
                }
            });
        });
        
        // Observar el body y todos sus descendientes con más opciones
        observer.observe(document.body || document.documentElement, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        });
        
        // También verificar periódicamente elementos críticos durante los primeros 5 segundos
        var startTime = Date.now();
        var checkInterval = setInterval(function() {
            var elapsed = Date.now() - startTime;
            if (elapsed > 5000) {
                clearInterval(checkInterval);
                return;
            }
            
            var summerTrendsContainer = document.querySelector('.summer-trends-container');
            if (summerTrendsContainer) {
                var windowWidth = window.innerWidth || document.documentElement.clientWidth;
                var minHeight = windowWidth >= 768 ? 326 : 700;
                checkAndRestoreHeight(summerTrendsContainer, minHeight, '100%');
            }
            
            var bottomFinder = document.querySelector('.bottom-finder');
            if (bottomFinder) {
                checkAndRestoreHeight(bottomFinder, 188, '100%');
            }
            
        }, 50); // Verificar cada 50ms durante los primeros 5 segundos
    }
    
    // Ejecutar inmediatamente si el DOM ya está listo
    if (document.readyState === 'loading') {
        // Si aún está cargando, ejecutar tan pronto como sea posible
        document.addEventListener('DOMContentLoaded', function() {
            // Configurar observer agresivo primero
            setupAggressiveObserver();
            // Usar requestAnimationFrame para ejecutar antes del primer paint
            requestAnimationFrame(function() {
                setInitialHeights();
            });
        });
    } else {
        // Si ya está listo, ejecutar inmediatamente
        setupAggressiveObserver();
        requestAnimationFrame(function() {
            setInitialHeights();
        });
    }
    
    // También ejecutar antes de que el body esté completamente listo
    if (document.body) {
        setupAggressiveObserver();
    } else {
        // Esperar a que el body esté disponible
        var bodyObserver = new MutationObserver(function(mutations, observer) {
            if (document.body) {
                setupAggressiveObserver();
                observer.disconnect();
            }
        });
        bodyObserver.observe(document.documentElement, {
            childList: true
        });
    }
    
    return {
        mountToApp: function mountToApp(application){
            var Layout = application.getComponent('Layout');
            
            // Inicializar observer de CLS
            if (typeof window !== 'undefined') {
                // Esperar a que el DOM esté listo
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', function() {
                        initCLSObserver();
                        // Establecer alturas iniciales inmediatamente
                        setInitialHeights();
                        // También establecer después de un pequeño delay para asegurar que se ejecute antes del CMS
                        setTimeout(setInitialHeights, 50);
                        setTimeout(setInitialHeights, 100);
                        setTimeout(setInitialHeights, 200);
                    });
                } else {
                    initCLSObserver();
                    // Establecer alturas iniciales inmediatamente
                    setInitialHeights();
                    setTimeout(setInitialHeights, 50);
                    setTimeout(setInitialHeights, 100);
                    setTimeout(setInitialHeights, 200);
                }
            }
            
            if (Layout) {
                // Establecer alturas antes de mostrar contenido
                Layout.on('beforeShowContent', function () {
                    setInitialHeights();
                });
                
                Layout.on('afterShowContent', function () {
                    // Establecer alturas después de mostrar contenido también
                    setTimeout(setInitialHeights, 50);
                    
                    // Facets sidebar affects CLS so we start with that hidden and show after 1000
                    if(jQuery(document).width() < 992){
                        _.delay(function(){
                            jQuery('.facets-facet-browse-facets').show();
                        },1000);
                    }
                });
            }
            
            // También usar MutationObserver para detectar cuando se agregan elementos al DOM
            if (typeof MutationObserver !== 'undefined') {
                var observer = new MutationObserver(function(mutations) {
                    var shouldSetHeights = false;
                    mutations.forEach(function(mutation) {
                        if (mutation.addedNodes.length > 0) {
                            var addedNodesArray = Array.prototype.slice.call(mutation.addedNodes);
                            addedNodesArray.forEach(function(node) {
                                if (node.nodeType === 1) { // Element node
                                    if (node.classList && (
                                        node.classList.contains('summer-trends-container') ||
                                        node.querySelector && node.querySelector('.summer-trends-container') ||
                                        node.classList && node.classList.contains('bottom-finder') ||
                                        node.querySelector && node.querySelector('.bottom-finder')
                                    )) {
                                        shouldSetHeights = true;
                                    }
                                }
                            });
                        }
                    });
                    if (shouldSetHeights) {
                        setTimeout(setInitialHeights, 10);
                    }
                });
                
                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            }
        }
    };
});
